export default [
  {
    title: 'Sobre a Crefaz',
    text: `
    A Crefaz Financiamentos e Investimentos é uma empresa especializada em microcrédito que nasceu no Paraná em 2013. Um de seus principais produtos é o Crefaz empréstimo na conta de luz.
    <br />
    Microcrédito é a concessão de empréstimos de baixo valor. Originalmente, esse tipo de empréstimo era voltado exclusivamente a pequenos empreendedores informais e microempresas sem acesso ao sistema financeiro tradicional. Por isso, trata-se de uma forma de democratizar o crédito no Brasil.`,
  },
  {
    title: 'O que é Crefaz empréstimo na conta de luz?',
    text: `
      Essa modalidade de crédito é perfeita para quem precisa de dinheiro com urgência. Com uma conta de energia em seu nome, fornecimento elétrico ativo no endereço e uma conta bancária no nome do titular da conta de energia;
      <br />
      Além disso, você terá mais facilidade para quitar seu empréstimo, pois as parcelas são debitadas direto na conta de energia. Assim você pode ter mais controle sobre suas contas e não corre o risco de pagar taxas por atraso nas parcelas.
    `,
  },
  {
    title: 'Quais são as etapas de solicitação da oferta pré-aprovada?',
    text: `
      É super simples!
      <br />
      <ol>
        <li>Após clicar em “Solicitar”;</li>
        <li>Você será redirecionado para o site da Crefaz para realizar uma simulação com seus dados</li>
      </ol>
      <br />
        É só enviar todos os dados e seguir o que se pede. Após concluir essa primeira etapa, você precisará baixar o aplicativo da parceira para dar continuidade.
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `
      - RG/CPF ou CNH.
      <br />
      - Fatura de energia em nome do titular com até 60 dias a partir da data de vencimento.
    `,
  },
  {
    title: `Posso alterar a data de vencimento da parcela do meu empréstimo pessoal?`,
    text: `Não, conforme consta em contrato, não é possível alterar a data de vencimento da parcela do seu empréstimo. O débito da parcela é feito em sua conta de luz.`,
  },
  {
    title: 'Qual a taxa de juros da Crefaz?',
    text: `A taxa de juros pode variar de até 15% ao mês e será calculada sempre proporcionalmente aos dias decorridos.`,
  },
  {
    title: 'Quais são os requisitos para pedir um empréstimo?',
    text: `Você precisa ter um CPF válido, ter mais de 18 anos, é necessário que a conta de energia esteja no nome de quem solicitou o empréstimo e não pode ter débitos em aberto com a companhia elétrica.`,
  },
  {
    title: 'Quais bancos são aceitos?',
    text: `Por enquanto, a Crefaz aceita grandes bancos como Caixa, Santander, Bradesco e Banco do Brasil, e também alguns bancos digitais como o Nubank. Não é aceito contas jurídica/empresarial, benefício ou salário.`,
  },
  {
    title: 'Quanto tempo demora para saber se fui aprovado?',
    text: `
      Após a assinatura digital da proposta de crédito, alguns clientes são aprovados minutos após o pedido do empréstimo pessoal. Em alguns casos, a Crefaz pedirá algumas informações por ligação. Isso pode incluir a validação da sua conta bancária, do seu telefone ou enviando documentos adicionais.
    `,
  },
]
